import { Helmet } from "react-helmet"
import { Heading, HeadingLevel } from "../../../ui/atoms/heading"

export const VisitingNotices: React.FC<any> = (_props) => {
    return (
      <>
        <Helmet>
          <title>Building Status</title>
        </Helmet>
        <Heading level={HeadingLevel.H1}>Building Status</Heading>
        
        <div className="space-y-5 mb-[5rem]">

          <article>
            <Heading level={HeadingLevel.H5}>Pool:</Heading>
            <p>
              <span className="px-3 py-1 mr-2 rounded-full font-semibold text-sm text-white  bg-slate-500">Closed for Season</span>
              The pool is closed for the season.
            </p>
          </article>
        </div>

        <Heading level={HeadingLevel.H1} className="mt-6">Upcoming Events</Heading>
        



        <Heading level={HeadingLevel.H1} className="mt-6">Notices</Heading>




      </>
    )
  }

